import skillsWarrior from "../skill-data/SkillsInfos/Warrior"
import skillsPaladin from "../skill-data/SkillsInfos/Paladin"
import skillsShooter from "../skill-data/SkillsInfos/Shooter"
import skillsDual from "../skill-data/SkillsInfos/Dual"
import skillsWarlock from "../skill-data/SkillsInfos/Warlock"
import skillsPriest from "../skill-data/SkillsInfos/Priest"

const importAll = (r) => {
    const images = {}
    r.keys().forEach((item) => {
        images[item.replace(".jpg", "").replace("./", "")] = r(item)
    })
    return images
}

const buildSkill = (require, displayClass) => {
    const images = importAll(require)
    const response = displayClass.map((skill) => {
        skill.logo = images[skill.logoId]
        return skill
    })
    return response
}

const SKILL_DATA = {
    gladiador: buildSkill(
        require.context("../assets/Warrior", false, /\.jpg$/),
        skillsWarrior
    ),
    paladino: buildSkill(
        require.context("../assets/Paladin", false, /\.jpg$/),
        skillsPaladin
    ),
    dinamitador: buildSkill(
        require.context("../assets/Shooter", false, /\.jpg$/),
        skillsShooter
    ),
    desperado: buildSkill(
        require.context("../assets/Dual", false, /\.jpg$/),
        skillsDual
    ),
    feiticeiro: buildSkill(
        require.context("../assets/Warlock", false, /\.jpg$/),
        skillsWarlock
    ),
    santo: buildSkill(
        require.context("../assets/Priest", false, /\.jpg$/),
        skillsPriest
    ),
}


export default SKILL_DATA
